







import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import formatter from '@/mixins/formatter';

@Component
export default class Price extends mixins(formatter) {
  @Prop() private price!: number;
  @Prop() private perMonth!: boolean;

  public unit(): string {
    return this.perMonth ? '円(税別)/月' : '円(税別)';
  }
}
